import type { Message } from './types';

export const CONVERSATION_USED_STORAGE_KEY = 'brainfish-conversation-used';
export const WELCOME_MESSAGE_ID = 'welcome';

const FIRST_VISIT_WELCOME_TEXT =
  "G’day! I'm Ask Brainfish. I answer questions about your product and business with citations, draft new articles from notes, files, videos, or our chat, and edit existing ones for review. Consider me your business’ SME, and co-pilot to be more affective in the Brainfish platform.\n\nHow can I help today?";

const RETURNING_WELCOME_TEXT = 'Hello! How can I help today?';

export function hasUsedConversationBefore(): boolean {
  try {
    return localStorage.getItem(CONVERSATION_USED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function markConversationAsUsed(): void {
  try {
    localStorage.setItem(CONVERSATION_USED_STORAGE_KEY, 'true');
  } catch {
    // localStorage might be unavailable, ignore
  }
}

export function getWelcomeText(isFirstVisit: boolean): string {
  return isFirstVisit ? FIRST_VISIT_WELCOME_TEXT : RETURNING_WELCOME_TEXT;
}

export const WELCOME_STREAM_CHUNK_SIZE = 3;
export const WELCOME_STREAM_INTERVAL_MS = 30;

function buildStreamingMessage(id: string, text: string, charIndex: number): Message {
  const chunk = text.slice(0, charIndex);
  const done = charIndex >= text.length;

  return {
    id,
    role: 'ai',
    content: chunk ? [{ type: 'text', text: chunk }] : [],
    status: done ? 'completed' : 'streaming',
  };
}

export function createWelcomeMessageAt(text: string, charIndex: number): Message {
  return buildStreamingMessage(WELCOME_MESSAGE_ID, text, charIndex);
}

export function streamTextAsMessage(
  id: string,
  text: string,
  onUpdate: (message: Message) => void,
  startCharIndex = WELCOME_STREAM_CHUNK_SIZE,
): () => void {
  let charIndex = startCharIndex;

  const interval = setInterval(() => {
    charIndex += WELCOME_STREAM_CHUNK_SIZE;
    const done = charIndex >= text.length;

    onUpdate(buildStreamingMessage(id, text, done ? text.length : charIndex));

    if (done) clearInterval(interval);
  }, WELCOME_STREAM_INTERVAL_MS);

  return () => clearInterval(interval);
}

export function streamWelcomeText(text: string, onUpdate: (message: Message) => void): () => void {
  return streamTextAsMessage(WELCOME_MESSAGE_ID, text, onUpdate);
}
